import { render, staticRenderFns } from "./JournalSummary.vue?vue&type=template&id=05e4107a&scoped=true"
import script from "./JournalSummary.vue?vue&type=script&lang=js"
export * from "./JournalSummary.vue?vue&type=script&lang=js"
import style0 from "./JournalSummary.vue?vue&type=style&index=0&id=05e4107a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e4107a",
  null
  
)

export default component.exports